// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsTemplate_content__tD0AG"};